<template>
  <v-menu v-model="model" :close-on-content-click="false" location="end">
    <template #activator="{ props: ActivatorProps }">
      <v-btn
        density="comfortable"
        :disabled="isLoading"
        icon="far fa-cog"
        size="small"
        v-bind="ActivatorProps"
      />
    </template>

    <v-card max-width="400">
      <v-card-item>
        <div class="d-flex flex-column justify-start">
          <v-label class="text-body-medium">
            {{ t('buttons.language') }}
          </v-label>
          <div>
            <DeepMenuLanguage
              v-model="settings.language"
              :available-locales="availableLocales"
              class="px-0"
              :close-on-content-click="false"
              color="primary"
              hide-icon
            />
          </div>
        </div>
      </v-card-item>

      <v-card-item>
        <v-label class="text-body-medium">
          {{ t('dialogs.summarize.size.label') }}
        </v-label>
        <v-sheet
          class="mx-auto d-flex align-center ga-2"
          color="on-surface"
          height="48"
          rounded="pill"
        >
          <v-btn
            v-for="nWordsItem in nWordsItems"
            :key="nWordsItem.id"
            color="primary"
            :rounded="nWordsItem.value === settings.nWords ? 'pill' : 'circle'"
            :text="nWordsItem.title"
            :variant="nWordsItem.value === settings.nWords ? 'flat' : 'plain'"
            @click="settings.nWords = nWordsItem.value"
          />
        </v-sheet>
        <div class="text-body-small d-flex align-center ga-2">
          <v-icon size="x-small">far fa-circle-info</v-icon>
          {{ t('dialogs.summarize.size.hint', settings.nWords) }}
        </div>
      </v-card-item>
      <v-divider class="my-4" />
      <v-card-actions>
        <v-spacer />
        <VBtnSecondary variant="text" @click="model = false">
          {{ t('buttons.cancel') }}
        </VBtnSecondary>
        <VBtnPrimary color="primary" @click="emit('click:apply')">
          {{ t('buttons.apply') }}
        </VBtnPrimary>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script lang="ts" setup>
import { DeepMenuLanguage } from '@deepcloud/deep-ui-lib';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

defineProps({
  isLoading: {
    type: Boolean,
    default: false
  }
});

const model = defineModel({ type: Boolean, default: false });
// TODO: improve types
const settings = defineModel('settings', { type: Object, default: () => ({}) });

const emit = defineEmits<{
  'click:apply': [];
}>();

const { t } = useI18n();

const nWordsItems = computed(() => [
  {
    id: 'short',
    title: t('dialogs.summarize.n_words_items.short'),
    value: 50
  },
  {
    id: 'middle',
    title: t('dialogs.summarize.n_words_items.middle'),
    value: 150
  },
  {
    id: 'long',
    title: t('dialogs.summarize.n_words_items.long'),
    value: 300
  }
]);

const availableLocales = computed(() => {
  const locales = ['de', 'en', 'it', 'fr'];
  return locales.filter((l) => l !== settings.value.language);
});
</script>
